export default {
  admin: () => import("/var/www/hladamchatu.sk/nuxt/layouts/admin.vue").then(m => m.default || m),
  web: () => import("/var/www/hladamchatu.sk/nuxt/layouts/web.vue").then(m => m.default || m)
}